const dataBlog = [
    {
        id: 1,
        srcimg: 'images/blog/blog-1.jpg',
        title: 'Learning, friendship and fun for everyone',
        time: '20.10.2019',
        like: '4',
        comments: '3',
        folder: 'Education',
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets.'
    },
    {
        id: 2,
        srcimg: 'images/blog/blog-2.jpg',
        title: 'Tips to developing a quality discussion',
        time: '20.10.2019',
        like: '4',
        comments: '3',
        folder: 'Education',
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets.'
    },
    {
        id: 3,
        srcimg: 'images/blog/blog-3.jpg',
        title: 'Designer bag bingo – new choices fundraiser',
        time: '20.10.2019',
        like: '4',
        comments: '3',
        folder: 'Education',
        description: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets.'
    },
    
]
export default dataBlog;